import React from "react"
import { TextInput, PasswordInput } from "@mantine/core"
import { ForgeRockFormProps } from "@models/forgeRock.model"

interface CredentialsInputsProps {
	username: string
	password: string
	disabled?: boolean
	readOnly?: boolean
	loginFormComponentData?: ForgeRockFormProps["loginFormComponentData"]
}

export const CredentialsInputs: React.FC<CredentialsInputsProps> = ({
	username,
	password,
	disabled = false,
	readOnly = false,
	loginFormComponentData
}) => {
	return (
		<>
			<TextInput
				placeholder={loginFormComponentData?.username}
				value={username}
				disabled={disabled}
				readOnly={readOnly}
				variant="login"
			/>
			<PasswordInput
				placeholder={loginFormComponentData?.password}
				value={password}
				disabled={disabled}
				readOnly={readOnly}
				variant="login"
			/>
		</>
	)
}
